/* Foto-hero-carousel op collectiepagina's: scroll-snap track met dots en
   pijlen. Geen dependencies; her-init-veilig via data-flag. */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-js-collection-hero]').forEach(function (hero) {
      if (hero.dataset.heroBound) return;
      hero.dataset.heroBound = '1';

      var track = hero.querySelector('.collection-hero__track');
      var slides = hero.querySelectorAll('.collection-hero__slide');
      var dots = hero.querySelectorAll('.collection-hero__dot');
      if (!track || slides.length < 2) return;

      function slideWidth() { return slides[0].getBoundingClientRect().width; }
      function index() { return Math.round(track.scrollLeft / slideWidth()); }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
      }
      function update() {
        var idx = index();
        dots.forEach(function (d, i) {
          d.classList.toggle('collection-hero__dot--active', i === idx);
        });
      }

      var prev = hero.querySelector('[data-js-hero-prev]');
      var next = hero.querySelector('[data-js-hero-next]');
      if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
      if (next) next.addEventListener('click', function () { goTo(index() + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { goTo(Number(d.dataset.index)); });
      });

      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(update, 80);
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
